import { useMutation, useQuery, useQueryClient } from "react-query";
import { createEmployeeAttachment, deleteEmployeeAttachment, fetchEmployeeAttachments, } from "@/features/employee/services/employeeService";
const useEmployeeAttachments = (employeeId) => {
    const queryClient = useQueryClient();
    const queryKey = ["employeeAttachments", employeeId];
    const { data, error, isLoading, refetch } = useQuery(queryKey, () => fetchEmployeeAttachments(employeeId), {
        enabled: Boolean(employeeId),
        staleTime: 60000,
    });
    const addAttachmentMutation = useMutation((payload) => createEmployeeAttachment(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries(queryKey);
        },
    });
    const deleteAttachmentMutation = useMutation((attachmentId) => deleteEmployeeAttachment(attachmentId), {
        onSuccess: () => {
            queryClient.invalidateQueries(queryKey);
        },
    });
    return {
        attachments: data?.items ?? [],
        loading: isLoading,
        error: error?.message ?? null,
        refetchAttachments: refetch,
        handleCreateAttachment: addAttachmentMutation.mutateAsync,
        handleDeleteAttachment: deleteAttachmentMutation.mutateAsync,
    };
};
export default useEmployeeAttachments;
